import React from 'react'
import Search from 'src/app/Search/Search'
import { SidenavContentType } from 'src/navigation/appLocations'
import { AppRoute } from 'src/navigation/appRoutes'
import AccountTransactionsAppRoute from 'src/navigation/appRoutes/account/accountTransactions.appRoute'
import AccountsAccountsAppRoute from 'src/navigation/appRoutes/accounts/accountsAccounts.appRoute'
import BudgetTransactionsAppRoute from 'src/navigation/appRoutes/budget/budgetTransactions.appRoute'
import ExpensesOutOfPocketReportsAppRoute from 'src/navigation/appRoutes/expenses/expensesOutOfPocketReports.appRoutes'
import ExpensesTransactionsAppRoute from 'src/navigation/appRoutes/expenses/expensesTransactions.appRoute'
import PeopleMembersAppRoute from 'src/navigation/appRoutes/people/peopleMembers.appRoute'
import VirtualCardsAllCardsAppRoute from 'src/navigation/appRoutes/virtualCards/virtualCardsAllCards.appRoute'
import VirtualCardsYourCardsAppRoute from 'src/navigation/appRoutes/virtualCards/virtualCardsYourCards.appRoute'
import { searchRouteProps } from 'src/navigation/routeProps'

import { AppLocation } from '../appLocations'

const SearchAppRoute: AppRoute = {
  id: AppLocation.Search,
  routeProps: searchRouteProps,
  component: <Search />,
  subRoutes: [],
  exceptions: [
    ExpensesTransactionsAppRoute,
    AccountTransactionsAppRoute,
    BudgetTransactionsAppRoute,
    VirtualCardsAllCardsAppRoute,
    VirtualCardsYourCardsAppRoute,
    AccountsAccountsAppRoute,
    PeopleMembersAppRoute,
    ExpensesOutOfPocketReportsAppRoute,
  ],
  meta: { contentType: SidenavContentType.Main },
}

export default SearchAppRoute
